import Header from "../../component/Header/Header";
import "../../App.css";
import SPLogin from "./SPLogin";
import QPPOSLogin from "./QPPOSLogin";
import EmployeeLogin from "./EmployeeLogin";
import React,{ useEffect, useState } from "react";
import { encrypt, decryp } from "../../Constant/Encrypt";
import { HTTPRequest } from "../../utilities/lib";
import { message } from "antd";
import constant from "../../utilities/constant";

function App() {
  const [paramsData, setParamsData] = useState();
  useEffect(() => {
    getQuery();
  }, []);
  const [intermedsubcatcd, setIntermedCategory] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [errorflag, seterrorFlag] = useState(false);
  const [errorval, seterrorVal] = useState('');
  //const [agentData, setAgentData] = useState([]);
  
  var aesEcb = require("aes-ecb");

  const getQuery = () => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let query = params.get("q");
    let clientid = params.get("clientid");
    var key = "lv39eptlvuhaqqer";
    if (query == null) {
      return;
    }
    if (query != null) {
      let encrypt = query.replace(/ /g, "+");
      let clientidEnc = clientid.replace(/ /g, "+");
      dataAuthenticate(encrypt,clientidEnc) ;
      //let dealerCode = JSON.parse(decryptedText).dealerCode;
    }
  };

  const dataAuthenticate = async (searchData,clientidEnc) => {
    setShowLoader(true);    
    try {    
      let params_data ={
        params:searchData,
        clientId:clientidEnc
      }

      let reqEncObj = {
        encodedString: aesEcb.encrypt(process.env.REACT_APP_CRYPTO_KEY,JSON.stringify(params_data))
      };
      console.log(searchData)
      let decryptdata = JSON.parse(aesEcb.decrypt(process.env.REACT_APP_CRYPTO_KEY,searchData));
      
      //console.log(decryptdata);
      let response_data = await HTTPRequest.POST('get-data',reqEncObj,  constant.PATH_AGENT_AUTHENTCATE);
      if(response_data.statusCode == constant.API_RESPONSE_CODE_200){
        let response = JSON.parse(aesEcb.decrypt(process.env.REACT_APP_CRYPTO_KEY,response_data.data));
        let final_data = response[0];
        //console.log(response);        
        var paramsData = {
          agentId: final_data.agentId,
          intermedsubcatcd: "SP",
          mobilenumber: final_data.mobileNo,
          parentagencyid:final_data.parentagencyid,
          authorization : false,
          skip: false,
          businesscreditchannel:final_data.channel,
          productName:"All Products",
          response:response,
          refCodeA:decryptdata?.refCodeA,
          refCodeB:decryptdata?.refCodeB,
          refCodeC:decryptdata?.refCodeC,
        };
        //console.log(paramsData)        
        setParamsData(paramsData);
        setIntermedCategory(paramsData.intermedsubcatcd);        
        seterrorFlag(false);
        setShowLoader(false);
      }else if(response_data.statusCode == constant.API_RESPONSE_CODE_400){
        let response = response_data.data;
        seterrorFlag(true);
        setShowLoader(false);
        message.error(response);
        seterrorVal(response);        
      }else if(response_data.statusCode == constant.API_RESPONSE_CODE_500){
        let response = response_data.data;
        seterrorFlag(true);
        setShowLoader(false);
        message.error(response);
        seterrorVal(response);        
      }else{
        let response = response_data.data;
        seterrorFlag(true);
        setShowLoader(false);
        message.error(response);
        seterrorVal(response);
      } 
    } catch (error) {
      seterrorFlag(true);
      setShowLoader(false);
      let response = error.response?.data?.error?.errorMessage;
      message.error(response);
      seterrorVal(response);
    }
  };

  const redirectPages = () => {
    if (intermedsubcatcd == "BROKER") {
      return <QPPOSLogin paramsData={paramsData} />;
    } else if (
      intermedsubcatcd == "SP" ||
      intermedsubcatcd == "AGENT" ||
      intermedsubcatcd == "IMF Broker Agent" ||
      intermedsubcatcd == "DUMMY" ||
      intermedsubcatcd == "POSP"
    ) {
      return <SPLogin paramsData={paramsData} />;
    } else if (intermedsubcatcd == "EMPLOYEE") {
      return <EmployeeLogin paramsData={paramsData} />;
    }else if (intermedsubcatcd == "POSP") {
      return <SPLogin paramsData={paramsData} />;
    }
  };
  return <>{intermedsubcatcd && redirectPages()}</>;
}

export default App;
